export default "__VITE_ASSET__DfApXrQd__"